<template>
  <!-- 课消统计折线图 -->
  <div>
    <div style="height: 30px;"><span @click="goBack" class="el-icon-circle-close"
        style="float: right; font-size: 24px;"></span></div>
    <div id="bottom" style="height: 400px; width: 100%;"></div>
    <div id="center" style="height: 400px; width: 100%;"></div>
    <div id="top" style="height: 400px; width: 100%;"></div>
    <div id="top1" style="height: 400px; width: 100%;"></div>
    <div id="bottom1" style="height: 400px; width: 100%;"></div>
    <div id="center1" style="height: 400px; width: 100%;"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import itemchartVue from '../../statistics/components/itemchart.vue';
export default {

  data () {
    return {
      dataObj: {},
      name: '',
    }
  },
  mounted () {
    let data = localStorage.getItem('dataObj')
    const dataObj1 = JSON.parse(data)
    this.dataObj = dataObj1.curve
    // console.log(this.dataObj);
    this.name = dataObj1.nameOrMonth
    this.line()
    this.lineCenter()
    this.lineBottom()
    this.line1()
    this.lineCenter1()
    this.lineBottom1()
  },
  created () {
  },
  methods: {
    //关闭按钮
    goBack () {
      history.back()
    },
    line () {
      var chartDom = document.getElementById('top');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        legend: {
          data: ['Email']
        },
        color: ['#5470c6'],
        tooltip: {
          trigger: 'axis'
        },
        // dataZoom: [{
        //   type: 'slider',
        //   show: true,
        //   start: 0,
        //   end: 30,
        //   xAxisIndex: [0]
        // }],
        title: {
          text: this.name + `教师平均课消统计图`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.dataObj.classMeanFee.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.dataObj.classMeanFee.map(item => item.num),
            type: 'line',
            smooth: true
          }
        ]
      };

      option && myChart.setOption(option);

    },
    lineCenter () {
      var chartDom = document.getElementById('center');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: ['#91cc75'],
        tooltip: {
          trigger: 'axis'
        },
        // dataZoom: [{
        //   type: 'slider',
        //   show: true,
        //   start: 0,
        //   end: 30,
        //   xAxisIndex: [0]
        // }],
        title: {
          text: this.name + `教师总课时数统计图`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.dataObj.classSumNum.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.dataObj.classSumNum.map(item => item.num),
            type: 'line',
            smooth: true
          }
        ]
      };

      option && myChart.setOption(option);

    },
    lineBottom () {
      var chartDom = document.getElementById('bottom');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: ['#fac858'],
        tooltip: {
          trigger: 'axis'
        },
        // dataZoom: [{
        //   type: 'slider',
        //   show: true,
        //   start: 0,
        //   end: 30,
        //   xAxisIndex: [0]
        // }],
        title: {
          text: this.name + `教师总课消统计图`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.dataObj.classSumFee.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.dataObj.classSumFee.map(item => item.num),
            type: 'line',
            smooth: true
          }
        ]
      };

      option && myChart.setOption(option);

    },
    line1 () {
      var chartDom = document.getElementById('top1');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        legend: {
          data: ['Email']
        },
        color: ['#ee6666'],
        tooltip: {
          trigger: 'axis'
        },
        // dataZoom: [{
        //   type: 'slider',
        //   show: true,
        //   start: 0,
        //   end: 30,
        //   xAxisIndex: [0]
        // }],
        title: {
          text: this.name + `教师当月每日总课消`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.dataObj.classSumFeeDay.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.dataObj.classSumFeeDay.map(item => item.num),
            type: 'line',
            smooth: true
          }
        ]
      };

      option && myChart.setOption(option);

    },
    lineCenter1 () {
      var chartDom = document.getElementById('center1');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: ['#73c0de'],
        tooltip: {
          trigger: 'axis'
        },
        // dataZoom: [{
        //   type: 'slider',
        //   show: true,
        //   start: 0,
        //   end: 30,
        //   xAxisIndex: [0]
        // }],
        title: {
          text: this.name + `教师当月每日平均课时费`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.dataObj.classMeanFeeDay.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.dataObj.classMeanFeeDay.map(item => item.num),
            type: 'line',
            smooth: true
          }
        ]
      };

      option && myChart.setOption(option);

    },
    lineBottom1 () {
      var chartDom = document.getElementById('bottom1');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: ['#fc8452'],
        tooltip: {
          trigger: 'axis'
        },
        // dataZoom: [{
        //   type: 'slider',
        //   show: true,
        //   start: 0,
        //   end: 30,
        //   xAxisIndex: [0]
        // }],
        title: {
          text: this.name + `教师当月每日总课时数`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.dataObj.classSumNumDay.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.dataObj.classSumNumDay.map(item => item.num),
            type: 'line',
            smooth: true
          }
        ]
      };

      option && myChart.setOption(option);

    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/manager/components/LineChart.vue